export enum FeatureFlag {
  canSeeEdCases = "seeEdCases",
  dashboard1FiltersOnDashboard2 = "dashboard1FiltersOnDashboard2",
  CaseInvite = "caseInvite",
  Ift = "ift",
  Mih = "mih",
  IftDispatch = "iftDispatch",
  canIftDispatch = "canIftDispatch",
  IftAssignEms = "iftAssignEms",
  IftBidHospitals = "iftBidHospitals",
  IftEmsCreateCases = "createIftCases",
  EdCreateCases = "hospitalCreateCase",
  printOnMarkAsArrived = "printOnMarkAsArrived",
  locationAlwaysOn = "locationAlwaysOn",
  mapClickCreateCase = "mapClickCreateCase",
  showEdCasesMihDashboard = "showEdCasesMihDashboard",
  useSessionStorage = "useSessionStorage",
  copyPastePtInfo = "copyPastePtInfo",
  hospitalFeedback = "hospitalFeedback",
  aiEnhancedProtocols = "aiEnhancedProtocols",
  showLinksOnly = "aiProtocolHideSummary",
  showAiProtocolFeedback = "showAiProtocolFeedback",
  hideInviteUsers = "hideInviteUsers",
  manageStatuses = "manageStatuses",
  canStartLiveConsult = "canStartLiveConsult",
  liveConsult = "liveConsult",
  IftDirectAssignConfirmation = "iftDirectAssignConfirmation",
}
